module.exports = require("./yue.d.ts");